import { RegistrationClient } from '@/../client-generator/generated-clients/api-clients';
import config from '@/core/config/config';
import axiosAuth from '../utilities/axios-instance';
const registrationClient = new RegistrationClient(config.baseApiUrl, axiosAuth);

export default registrationClient;
